import styled from '@emotion/styled';

import { Breakpoints } from 'utils/const.styles';

export const Card = styled.div`
	background-color: ${({ formBackgroundColor }) => (formBackgroundColor ? `${formBackgroundColor}` : '#ffffff')};
	border-radius: 10px;
	box-shadow: var(--container-box-shadow);
	width: 100%;
	margin-left: auto;
	margin-right: auto;
	padding: 15px;
	@media ${Breakpoints.mobile} {
		max-width: 90%;
	}
	> div {
		display: block;
	}
`;

export const TransparentCard = styled.div`
	margin-top: 20px;
	border-radius: 10px;
	width: 100%;
	margin-left: auto;
	margin-right: auto;
	@media ${Breakpoints.mobile} {
		max-width: 90%;
	}
`;
export const SaveButtonDesign = styled.div`
	> button {
		background-color: ${({ saveButtonColor }) => (saveButtonColor ? `${saveButtonColor}` : '#1bc487')} !important;
		border-color: ${({ saveButtonColor }) => (saveButtonColor ? `${saveButtonColor}` : '#1bc487')} !important;
		color: ${({ saveButtonTextColor }) => (saveButtonTextColor ? `${saveButtonTextColor}` : '#ffffff')} !important;
		> span {
			font-size: var(--paragraph3-font-size) !important;
			font-weight: bold !important;
		}
	}
`;

export const FormItemsWrapper = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr;

	.form-item {
		width: 100%;
	}

	@media ${Breakpoints.mobile} {
		grid-template-columns: 1fr;
	}
`;

export const FormWrapper = styled.div`
	> form {
		background-color: ${({ formBackgroundColor }) => (formBackgroundColor ? `${formBackgroundColor}` : '#ffffff')};
		color: ${({ color }) => (color ? `${color}` : '#000000')};
		width: 100%;
		display: flex;
		flex-direction: column;
		margin-top: 1rem;
	}
`;
